<script setup lang="ts">
  const form = reactive({
    email: '',
  })

  const pending = ref(false)
  const success = ref(false)
  const error = ref('')

  async function forgotPassword() {
    try {
      pending.value = true
      error.value = ''

      await $fetch('/api/auth/forgot-password', {
        method: 'POST',
        body: form,
      })

      success.value = true
    } catch (err: any) {
      error.value = err.data?.message || 'Failed to send reset email'
    } finally {
      pending.value = false
    }
  }
</script>

<template>
  <div class="max-w-md mx-auto">
    <div v-if="success" class="text-center space-y-4">
      <UIcon
        name="i-lucide-mail-check"
        class="w-16 h-16 mx-auto text-green-500"
      />
      <h1 class="text-2xl font-bold text-green-700">Check Your Email</h1>
      <p class="text-gray-600">
        If an account with this email exists, you will receive a password reset
        link.
      </p>
      <UButton to="/login" label="Back to Login" color="primary" />
    </div>

    <div v-else>
      <h1 class="text-2xl font-bold mb-6">Reset Password</h1>
      <p class="text-gray-600 mb-6">
        Enter your email address and we'll send you a link to reset your
        password.
      </p>

      <form @submit.prevent="forgotPassword" class="space-y-4">
        <UFormGroup label="Email">
          <UInput
            v-model="form.email"
            type="email"
            placeholder="Enter your email"
            required
          />
        </UFormGroup>

        <UAlert
          v-if="error"
          color="error"
          variant="soft"
          :title="error"
          class="mb-4"
        />

        <UButton type="submit" :loading="pending" block>
          Send Reset Link
        </UButton>
      </form>

      <div class="mt-6 text-center">
        <p class="text-sm text-gray-600">
          Remember your password?
          <NuxtLink to="/login" class="text-primary-600 hover:text-primary-500">
            Back to Login
          </NuxtLink>
        </p>
      </div>
    </div>
  </div>
</template>
